import "./doubled_gallery.css";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    let current = 0;

    const gallery = document.getElementById("doubled_gallery");
    const items = document.querySelectorAll(".doubled_gallery_item");
    const left = document.getElementById("doubled_gallery_navigation_left");
    const right = document.getElementById("doubled_gallery_navigation_right");
    const buttons = document.querySelectorAll(
      ".doubled_gallery_mobile_navigation span",
    );

    if (!gallery) return;

    const lastIndex =
      window.innerWidth >= 992 ? items.length - 2 : items.length - 1;

    const shift = items[0].clientWidth + 20; // 20 - gap

    const update = () => {
      gallery.scrollLeft = current * shift;
    };

    left.addEventListener("click", () => {
      current--;
      // double click fix
      if (current < 0) {
        current = 0;
      }

      if (current === 0) {
        left.classList.add("doubled_gallery_navigation_hidden");
      }
      right.classList.remove("doubled_gallery_navigation_hidden");
      update();
    });

    right.addEventListener("click", () => {
      current++;
      // double click fix
      if (current > lastIndex) {
        current = lastIndex;
      }
      update();

      if (current === lastIndex) {
        right.classList.add("doubled_gallery_navigation_hidden");
      }
      left.classList.remove("doubled_gallery_navigation_hidden");
    });

    const removeAllActive = () => {
      buttons.forEach(function (btn, index) {
        btn.classList.remove("doubled_gallery_navigation_item_active");
      });
    };

    buttons[0].classList.add("doubled_gallery_navigation_item_active");

    buttons.forEach(function (btn, index) {
      btn.addEventListener("click", function () {
        current = index;
        update();
      });
    });

    gallery.addEventListener("scroll", () => {
      if (window.innerWidth < 992) {
        current = Math.round(gallery.scrollLeft / shift);
        removeAllActive();
        buttons[current].classList.add(
          "doubled_gallery_navigation_item_active",
        );
      }
    });
  },
  false,
);
